import { ONBOARDING_TAB_IDS } from '../../constants';

export const ONBOARDING_FOOTER_BUTTON_LABELS = {
  PREVIOUS: 'Previous',
  NEXT: 'Next',
  CONCLUDE: 'Conclude',
} as const;

export const CONCLUDE_REQUIRED_TAB_IDS = [
  ONBOARDING_TAB_IDS.GENERAL,
  ONBOARDING_TAB_IDS.PRIMARY_INSURANCE,
  ONBOARDING_TAB_IDS.REFERRAL,
  ONBOARDING_TAB_IDS.AGREEMENT,
] as const;
